export var PRIMARY_COLOR = '#ffffff';
export var BALL_SIZE = '15px';
export var MARGIN = '2px';
export var LINE_HEIGHT = '35px';
export var LINE_WIDTH = '4px';